module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-15.7c76ac20.png";